import { Stack, Typography } from "@mui/material";
import { ThemeConsumer } from "styled-components";

const PreviewGridItemWrapper = ({ label, value }) => {
  return (
    <Stack sx={{ p: 1.5, border: 0.05, borderColor: "grey.gs" }}>
      <Typography variant="body2" color="text.caption" textAlign="left" fontWeight="fontWeightRegular">
        {label}:
      </Typography>
      <Typography variant="body2" color="text.primary" textAlign="left" fontWeight="fontWeightMedium">
        {value}
      </Typography>
    </Stack>
  );
};

export default PreviewGridItemWrapper;
